export default __webpack_public_path__ + "static/Connect-8c9be9129214a9110229534531efacae.png";